<script setup lang="ts">
import type { SiteBlockData, SiteBlockSettings } from '~/types/types'

/**
 * Renders an admin-uploaded HTML file inside a sandboxed iframe. `allow-scripts`
 * is set without `allow-same-origin`, so the embedded document runs its own
 * scripts but gets an opaque origin — it cannot read this page's cookies,
 * localStorage, or DOM regardless of what the uploaded file contains.
 */
defineProps<{ data: SiteBlockData, settings: SiteBlockSettings }>()
</script>

<template>
  <iframe
    v-if="data.file_url"
    :src="data.file_url"
    sandbox="allow-scripts"
    referrerpolicy="no-referrer"
    loading="lazy"
    class="w-full rounded-[var(--site-radius)] border border-[var(--site-border)]"
    :style="{ height: `${data.height || 600}px` }"
  />
  <div
    v-else
    class="rounded-[var(--site-radius)] border border-dashed border-[var(--site-border)] p-8 text-center text-sm text-[var(--site-muted)]"
  >
    Upload an HTML file to display it here.
  </div>
</template>
